import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    deleteConcept,
    getAllConcept,
    getConceptById,
    getListByConceptType,
    pagingConcept,
    pagingIndicator,
    saveConcept,
    saveIndicator,
    saveIngredientSyncStore
} from 'app/services/ConceptService';
import { Concept } from "app/common/Model/Concept";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { importConceptExcel, importExcelConceptIndicator } from "app/services/ImportExcelService";
import { pagingConceptType } from "app/services/ConceptTypeService";

export default class ConceptStore {
    listAllConcept = [];
    searchConcept = new SearchObject();
    pageConcept = null;
    selectedConcept = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteConcept = false;
    openSyncStore = false;
    openImportExcel = false;
    isIndicator = false;

    openImportExcelIndicator = false;

    constructor() {
        makeAutoObservable(this);
    }
    handleOpenImportExcelIndicator = () => {
        this.openImportExcelIndicator = true;
    }
    handleCloseImportExcelIndicator = () => {
        this.openImportExcelIndicator = false;
    }

    handleSetIndicator = () => {
        this.isIndicator = true;
    }

    handleOpenImportExcel = () => {
        this.openImportExcel = true;
    }
    handleCloseImportExcel = () => {
        this.openImportExcel = false;
    };
    saveImportExcelConceptIndicator = (file) => {
        importExcelConceptIndicator(file).then(() => {
            toast.success("Nhập excel thành công")
            this.searchConcept = {
                ...this.searchConcept,
                pageIndex: 1
            }
            if (this.isIndicator) {
                this.pagingIndicator()
            } else { this.pagingConcept() }
            this.openImportExcelIndicator = false;
            this.openImportExcel = false;
        }).catch(() => {
            toast.error("Nhập excel thất bại")
        }).
            finally(() => {
                this.handleClosePopup();
            })
    }
    saveImportExcelConcept = (file) => {
        importConceptExcel(file).then(() => {
            toast.success("Nhập excel thành công")
            this.searchConcept = {
                ...this.searchConcept,
                pageIndex: 1
            }
            if (this.isIndicator) {
                this.pagingIndicator()
            } else { this.pagingConcept() }
            this.openImportExcel = false;
        }).catch(() => {
            toast.error("Nhập excel thất bại")
        }).
            finally(() => {
                this.handleClosePopup();
            })
    }

    getListByConceptType = (code) => {
        if (this.listAllConcept?.length === 0) {
            getListByConceptType(code)
                .then(({ data }) => this.listAllConcept = data)
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                });
        }
    }
    getAllConcept = () => {
        if (this.listAllConcept?.length === 0) {
            getAllConcept()
                .then(({ data }) => this.listAllConcept = data)
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                });
        }
    }

    pagingIndicator = async (searchObj) => {
        let newSearchObj = { ...this.searchConcept, ...searchObj }
        newSearchObj ={
            ...newSearchObj,
            keyword: (newSearchObj?.keyword && newSearchObj?.keyword !== '') ?  newSearchObj?.keyword.trim() : null
        }
        return await pagingIndicator(newSearchObj)
            .then(({ data }) => {
                this.pageConcept = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }
    pagingConcept = async (searchObj) => {
        let newSearchObj = { ...this.searchConcept, ...searchObj }
        return await pagingConcept(newSearchObj)
            .then(({ data }) => {
                this.pageConcept = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchConcept) => {
        // this.searchConcept = checkSearchObject(this.searchConcept, searchConcept);
        this.searchConcept = { ...this.searchConcept, ...searchConcept, pageSize: searchConcept?.pageSize ?? this.searchConcept?.pageSize, pageIndex: searchConcept?.pageSize ? 1 : (searchConcept?.pageIndex ?? this.searchConcept?.pageIndex) }
        if (this.isIndicator) {
            this.pagingIndicator()
        } else { this.pagingConcept() }

    }

    handleOpenFormCreateOrEdit =async (conceptId,type) => {
        if (Boolean(conceptId)) {
            getConceptById(conceptId)
                .then(({ data }) => {
                    this.selectedConcept = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            if(type) {
                const {data}  =await  pagingConceptType({
                    keyword:type,
                    pageIndex:1,
                    pageSize:1
                })
                this.selectedConcept = {...new Concept(),conceptType:data?.content[0]};
            }else {
                this.selectedConcept =new Concept()
            }
            this.openFormCreateOrEdit = true;
        }
    }

    saveIndicator = async (concept, { setSubmitting }) => {
        return await saveIndicator(concept).then(() => {
            this.selectedConcept = null;
            toast.success("Lưu chỉ số thành công!");
            this.handleClosePopup();
            if (this.isIndicator) {
                this.pagingIndicator()
            } else { this.pagingConcept() }

        })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin chỉ số có lỗi");
            })
            .finally(() => setSubmitting(false))
    }
    saveConcept = async (concept, { setSubmitting }) => {
        return await saveConcept(concept).then(({data}) => {
            this.selectedConcept = null;
            toast.success("Lưu khái niệm thành công!");
            this.handleClosePopup();
            if (this.isIndicator) {
                this.pagingIndicator()
            } else { this.pagingConcept() }
            return data

        })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin khái niệm có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteConcept = (concept) => {
        this.selectedConcept = { id: concept?.id };
        this.openConfirmDeleteConcept = true;
    }

    handleConfirmDeleteConcept = () => deleteConcept(this?.selectedConcept?.id)
        .then(() => {
            if (this.searchConcept.pageIndex > 1 && this.pageConcept?.content?.length === 1) {
                this.searchConcept.pageIndex -= 1;
            }
            toast.success("Xóa khái niệm thành công!")
            this.handleClosePopup();
            if (this.isIndicator) {
                this.pagingIndicator()
            } else { this.pagingConcept() }

        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa khái niệm có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteConcept = false;
        this.openImportExcel = false;
    }

    resetStore = () => {
        this.searchConcept = new SearchObject();
        this.pageConcept = null;
        this.selectedConcept = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteConcept = false;
        this.isIndicator = false;
    }


    //for choosing personal history popup in ChoosePersonalHistoryPopup.jsx ,
    //for choosing family history popup in ChooseFamilyHistoryPopup.jsx 
    //and choosing allergies history popup in ChooseAllergyPopup.jsx
    listItem = [];
    itemIdSet = null;

    convertToEhMedicalHistoryDto = concept => {
        const dto = {
            id: concept?.id || concept?.conceptId,
            conceptId: concept?.conceptId || concept?.id,
            conceptName: concept?.conceptName || concept?.name,
            conceptCode: concept?.conceptCode || concept?.code,
            code: concept?.code || concept?.conceptCode,
            name: concept?.name || concept?.conceptName,
            icdCode10: concept?.icdCode10 || "",
            drugs: concept?.drugs || []
        };
        return dto;
    }

    isValidItem = item => {
        if (item && (item?.id || item?.conceptId)) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addItem = item => {
        if (!this.isValidItem(item)) return;
        this.listItem.push(this.convertToEhMedicalHistoryDto(item));
        this.itemIdSet.add(item?.id || item?.conceptId);
    }

    initializeListItem = items => {
        this.itemIdSet = new Set();
        this.listItem = [];
        if (items && items?.length > 0) {
            for (let i = 0; i < items.length; i++) {
                this.addItem(items[i]);
            }
        }
    }

    removeItem = item => {
        if (!this.isValidItem(item)) return;
        if (this.itemIdSet.has(item?.id)) {
            this.itemIdSet.delete(item?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = item => {
        if (!this.isValidItem(item)) return;
        return this.itemIdSet.has(item?.id);
    }

    getItemIdSet = () => {
        return this.itemIdSet;
    }

    getListItem = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listItem && this.listItem?.length > 0) {
            for (let i = 0; i < this.listItem.length; i++) {
                const item = this.listItem[i];
                if (this.isExist(item) && !bufferIdSet.has(item?.id)) {
                    data.push(item);
                    bufferIdSet.add(item?.id);
                }
            }
        }
        this.listItem = data;
        return data;
    }
    //end

    handleCloseSyncStore = () => {
        this.openSyncStore = false
    }

    handleOpenSyncStore = () => {
        this.openSyncStore = true
    }

    handleSaveSyncStore = (data, { setSubmitting }) => {
        saveIngredientSyncStore(data).then(() => {
            this.handleCloseSyncStore();
            toast.success("Đồng bộ hoạt chất thành công");
            this.pagingConcept(this.searchConcept);
        }).catch((err) => {
            console.error(err);
            toast.error("Đồng bộ hoạt chất thất bại")
        }).finally(() => {
            setSubmitting(false)
        })
    }
}